import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'

import { Order as OrderModel } from 'msp-integrations'
import { Icons, CustomLinkComponent } from 'msp-components'

import OrderStatus from '@/components/atoms/OrderStatus/OrderStatus'
import OrderTracking from '@/components/molecules/OrderTracking/OrderTracking'
import OrderDeliveryDate from '@/components/atoms/OrderDeliveryDate/OrderDeliveryDate'

import translations from './OrderStatuses.constants'
import * as S from './OrderStatuses.styles'

const OrderStatuses = ({ order }: { order: OrderModel }) => {
  const { formatMessage, formatDate } = useIntl()
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions

  return (
    <>
      <div className={S.HeadWrapper}>
        <div className={''}>#{order.orderNo}</div>
        <div className={''}>
          {formatDate(new Date(order.creationDate), dateFormattingOpts)}
        </div>
      </div>
      <div className={S.StatusesWrapper}>
        <div className={S.StatusesLeftColumnWrapper}>
          <OrderStatus order={order} className={S.OrderStatus} />
          <OrderDeliveryDate order={order} className={S.OrderDeliveryDate} />
          <OrderTracking order={order} />
        </div>
        {order.hasInvoices() && (
          <div className={S.StatusesRightColumnWrapper}>
            {order.c_invoice.map((document, index) => (
              <CustomLinkComponent
                key={`slip-${document.id}-${index}`}
                className={S.OrderInvoiceItemWrapper}
                title={document.fileName || document.invoiceNo}
                uppercase={false}
                href={document.url}
                openInNewTab
                isExternalLink
                inline
              >
                <div className={S.OrderInvoiceItemIcon}>
                  <Icons iconName='OrderInvoice' size='sm' />
                </div>
                <div className={S.OrderInvoiceItemName}>
                  {document.type === 'INVOICE' &&
                    formatMessage(translations.downloadInvoice, {
                      documentNo: document.invoiceNo
                    })}
                  {document.type === 'REFUND' &&
                    formatMessage(translations.downloadRefund, {
                      documentNo: document.invoiceNo
                    })}
                </div>
              </CustomLinkComponent>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default OrderStatuses
